import { render, staticRenderFns } from "./SingleTable.vue?vue&type=template&id=760513dd&scoped=true&"
import script from "./SingleTable.vue?vue&type=script&lang=js&"
export * from "./SingleTable.vue?vue&type=script&lang=js&"
import style0 from "./SingleTable.vue?vue&type=style&index=0&id=760513dd&lang=scss&scoped=true&"
import style1 from "./SingleTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760513dd",
  null
  
)

export default component.exports